import createReducer from 'reducers/createReducer';

import {ShopClientInfo, SignIn} from 'actions/actionTypes';

const INITIAL_STATE = {
    id: '',
    password: '',
    remember: false,

    error: {
        triggered: false,
        message: ''
    },
};

const reducer = createReducer(INITIAL_STATE, {
    [SignIn.CHANGE_ID]: (state, action) => state.id = action.payload,
    [SignIn.CHANGE_PASSWORD]: (state, action) => state.password = action.payload,
    [SignIn.CHANGE_REMEMBER]: (state, action) => state.remember = action.payload,

    [SignIn.RESET_DATA]: (state, action) => {
        state.id = '';
        state.password = '';
        state.remember = false;
    },

    [SignIn.SIGN_IN_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
});

export default reducer;